module.exports = __webpack_public_path__ + "img/title-1.87ba35e6.png";